import { CleaningStatusColor } from '../types';

/**
 * Maps a cleaning status string (from the `cleanStatus` attribute's
 * `allowedValues`) to the `Chip` colour used to render it.
 *
 * Unknown / empty statuses fall back to `default`.
 */
export const getStatusChipColor = (status?: string): CleaningStatusColor => {
  switch (status) {
    case 'Completed':
      return 'success';
    case 'Due':
      return 'primary';
    case 'Overdue - Due':
    case 'Overdue - Completed':
      return 'warning';
    case 'Missed':
      return 'error';
    case 'Not required':
    default:
      return 'default';
  }
};
